<template>
  <div v-if="$store.state.brokerModule.broker != null && $store.state.brokerModule.broker.user_id == $store.state.user.id" 
    class="w-full">

    <div class="flex items-center justify-between">
      <div class="text-2xl font-thin">
        Welcome {{ $store.state.brokerModule.broker.first_name }}
      </div>

      <div class="flex items-center">
        <input type="checkbox" 
          id="input-show-home-page" 
          :checked="broker.should_show_landing"
          :value="broker.should_show_landing"
          v-on:change="shouldShowLandingChanged($event.target.checked)" />
        <label for="input-show-home-page" class="ml-2">Show this page each time you log in</label>
      </div>
    </div>

    <div class="text-sm font-semibold text-gray-600 mt-8">
      Overview
    </div>

    <div class="flex flex-wrap mt-2 -mx-2" v-if="stats != null">
      <div class="w-1/6 px-2">
        <div class="bg-white p-4 rounded-lg shadow-lg border">
          <div class="text-center">
            <div class="text-2xl text-blue-800">{{ stats.active + stats.settled }}</div>
            <div class="mt-1 text-gray-600">Total Clients</div>
          </div>
        </div>
      </div>

      <div class="w-1/6 px-2">
        <div class="bg-white p-4 rounded-lg shadow-lg border">
          <div class="text-center">
            <div class="text-2xl text-blue-800">{{ stats.active }}</div>
            <div class="mt-1 text-gray-600">Active Clients</div>
          </div>
        </div>
      </div>

      <div class="w-1/6 px-2">
        <div class="bg-white p-4 rounded-lg shadow-lg border">
          <div class="text-center">
            <div class="text-2xl text-blue-800">{{ stats.settled }}</div>
            <div class="mt-1 text-gray-600">Settled Clients</div>
          </div>
        </div>
      </div>

      <div class="w-1/6 px-2">
        <div class="bg-white p-4 rounded-lg shadow-lg border">
          <div class="text-center">
            <div class="text-2xl text-blue-800">{{ stats.today }}</div>
            <div class="mt-1 text-gray-600">Clients Added Today</div>
          </div>
        </div>
      </div>

      <div class="w-1/6 px-2">
        <div class="bg-white p-4 rounded-lg shadow-lg border">
          <div class="text-center">
            <div class="text-2xl text-blue-800">{{ stats.emails }}</div>
            <div class="mt-1 text-gray-600">Applications Emailed Out</div>
          </div>
        </div>
      </div>

      <div class="w-1/6 px-2">
        <div class="bg-white p-4 rounded-lg shadow-lg border">
          <div class="text-center">
            <div class="text-2xl text-blue-800">${{ stats.totalLoanValue }}</div>
            <div class="mt-1 text-gray-600">Total Loan Amount</div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap mt-8 -mx-8">
      <div class="w-1/2 px-8">
        <div class="mt-12" v-if="chartData != null">
          <div class="text-sm font-semibold text-gray-600">
            Clients added per week for the past 20 weeks
          </div>

          <div class="mt-6">
            <BarChart :chartData="chartData" :height="600"></BarChart>
          </div>          
        </div>
      </div>

      <div class="w-1/2 px-8">
        <div class="mt-12" v-if="pieChartData != null">
          <div class="text-sm font-semibold text-gray-600">
            Breakdown of Client acquisition by source type
          </div>
          <div class="mt-6">
            <PieChart :pieChartData="pieChartData" :height="600"></PieChart>
          </div>
        </div>
      </div>

      <div class="w-1/2 px-8">
        <div class="mt-12">
          <div class="text-sm font-semibold text-gray-600">
            Recent Client Activities
          </div>

          <div class="" v-if="activities != null">
            <template v-for="(activity, index) in activities">
              <div class="mt-2 border border-gray-400 p-2 rounded text-sm">
                <router-link 
                  :to="{
                    name  : 'application-applicant-profile',
                    params: {
                      clientId   : activity.causer_id,
                      applicantId: activity.applicant_id
                    }
                  }"
                  tag="a" 
                  class="no-underline text-blue-500">
                  <template v-if="activity.first_name != null">
                    {{ activity.first_name }} {{ activity.last_name }} 
                  </template>

                  <template v-else>
                    [None]
                  </template>
                </router-link>



                <template v-if="activity.description == 'document-visited'">
                  accessed documents.
                </template>

                <template v-else-if="activity.description == 'asset-edited'">
                  updated assets.
                </template>

                <template v-else-if="activity.description == 'welcome-visited'">
                  signed in.
                </template>

                <template v-else-if="activity.description == 'expense-visited'">
                  updated living expenses.
                </template>

                <template v-else-if="activity.description == 'submit-by-client'">
                  submitted the application form.
                </template>

                <template v-else-if="activity.description == 'page-edited'">
                  updated the information in the form.
                </template>

                <div class="mt-1 text-gray-700">
                  {{ getFormattedDate(activity.updated_at, 'YYYY-MM-DD HH:mm:ss', 'D MMM YYYY HH:mm') }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <br/><br/><br/>

    <ConfirmRegistrationModal />
    <FreeVersionNoticeModal />
    <MFANoticeModal />
  </div>
</template>

<script>
  import ConfirmRegistrationModal from '@/shared/components/modals/ConfirmRegistrationModal'
  import FreeVersionNoticeModal   from '@/shared/components/modals/FreeVersionNoticeModal'
  import MFANoticeModal           from '@/shared/components/modals/MFANoticeModal'
  import Footer                   from '@/shared/components/Footer'
  import BarChart                 from '@/shared/components/charts/Bar.js'
  import PieChart                 from '@/shared/components/charts/PieChart.js'

  export default {
    components: {
      ConfirmRegistrationModal,
      FreeVersionNoticeModal,
      MFANoticeModal,
      Footer,
      BarChart,
      PieChart
    },

    data() {
      return {
        query     : null,
        broker    : _.cloneDeep(this.$store.state.brokerModule.broker),
        stats     : null,
        chartData : null,
        pieChartData: null,
        activities: null
      }
    },

    created() {
      // broker can only been seen if current user == current broker
      if(this.$store.state.brokerModule.broker != null && this.$store.state.brokerModule.broker.user_id == this.$store.state.user.id) {

      } else {
        this.$router.push({
          name: 'auth-login'
        })
      }

      // get some stats
      this.apiGet({}, 'broker/stats', (stats) => {
        this.stats = stats
      })

      // get chart data
      this.getChartData()
      this.getPieChartData()
      // get last 20 clients with email sent
      this.getClientActivities()
    },

    mounted() {
      if(!this.$store.state.user.mfa_enabled && this.$cookies.get('ignore-mfa-modal') == null) {
        this.$modal.show('mfa-notice-modal')
      }
      
      if(this.$route.params.showConfirmRegistration != null && this.$route.params.showConfirmRegistration == 1) {
        this.$modal.show('confirm-registration-modal')
      }

      if(this.$store.state.user.free_version_notice) {
        this.$modal.show('free-version-notice-modal')
      }
    },

    methods : {
      shouldShowLandingChanged(shouldShow) {
        this.updateBroker(this.broker, 'should_show_landing', shouldShow)
      },

      getChartData() {
        this.apiGet({
          year : this.$route.params.year
        }, 'broker/clients-per-week', (data) => {
          this.chartData = data;
        })
      },

      getPieChartData() {
        this.apiGet({}, 'client-source/chart-data', (data) => {
          this.pieChartData = data;
        })
      },

      getClientActivities() {
        this.apiGet({
          year : this.$route.params.year
        }, 'broker/client-activities', (data) => {
          this.activities = data
        })
      },
    }
  }
</script>